module.exports = __webpack_public_path__ + "static/media/kw.6398282a.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/kw.svg
// module id = 2135
// module chunks = 0